<div class="flex flex-col">
  <p-toast></p-toast>
  <app-header class="z-20"></app-header>

  @if (!authenticated) {
    <app-login class="mt-2"></app-login>
  } @else {
    <p-tabView class="p-0">
      @if (isExcel) {
        <p-tabPanel header="{{ myTranslation('officeAddin.dataImport') }}" class="p-0">
          <p-blockUI [target]="pnl" [blocked]="isBusy" class="z-10">
            <p-progressSpinner styleClass=""></p-progressSpinner>
          </p-blockUI>
          <p-card #pnl id="pnl" class="shadow-none">
            <new-ui-progress-bar></new-ui-progress-bar>
            <div class="flex flex-col gap-3 h-full">
              <app-candidate-data (isBusy)="setBusyState($event)" class=""></app-candidate-data>

              <p-divider />

              <app-change-statistics (isBusy)="setBusyState($event)" class=""></app-change-statistics>

              <p-divider />
              @if (isMasterUser) {
                <app-sales-data (isBusy)="setBusyState($event)"></app-sales-data>

                <p-divider />

                <app-lingoking-data (isBusy)="setBusyState($event)" class=""></app-lingoking-data>

                <p-divider />

                <app-billing-data (isBusy)="setBusyState($event)" class=""></app-billing-data>
              }
            </div>
          </p-card>
        </p-tabPanel>
      }
      <p-tabPanel header="{{ myTranslation('officeAddin.knownVariables') }}">
        <p-card>
          <app-known-variables></app-known-variables>
        </p-card>
      </p-tabPanel>
    </p-tabView>
  }
</div>
